import type { OrderDetailResponseDto } from "Infrastructure/Api/Api";
import { useB2B } from "Order/Components/Form/Hooks/useB2B";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import Input from "Shared/Components/Form/CustomFormComponent/Input";
import Select from "Shared/Components/Form/CustomFormComponent/Select";
import { Grid2 } from "@mui/material";
import { useFormContext } from "react-hook-form";

type Props = {
	order: OrderDetailResponseDto;
};

export function B2BPromoForm({ order }: Props) {
	const { b2bOptions } = useB2B(order.market);
	const {
		control,
		formState: { errors },
	} = useFormContext();

	return (
		<BaseCard title="B2B & Promo">
			<Grid2 container spacing={2}>
				<Grid2 size={{ xs: 12 }}>
					<Select
						id="b2b"
						name="b2b"
						label="B2B status"
						variant="outlined"
						control={control}
						errors={errors}
						options={b2bOptions}
						fullWidth
					/>
				</Grid2>
				<Grid2 size={{ xs: 12 }}>
					<Input
						id="promoCode"
						name="promoCode"
						label="Promo code"
						variant="outlined"
						control={control}
						errors={errors}
						fullWidth
					/>
				</Grid2>
			</Grid2>
		</BaseCard>
	);
}
